import $ from 'jquery';

class ImageEnlarger {
    constructor() {
        this.header = document.querySelectorAll('.fc-header');
        this.active = false;
        this.currentScroll = null;
        this.images = [].slice.call(document.querySelectorAll('.inline-large:not(.processed), .inline-xlarge:not(.processed)'));
        this.article = document.querySelector('.post-article');
        this.navs = [].slice.call(document.querySelectorAll('.navbar-brands-container, .reading-bar'));
    }

    init() {
        this.setListeners();
        this.processPoster();
    }

    processPoster() {
        let test = document.querySelector('.fc-header .poster-wrapper:not(.processed) :nth-child(1)');

        if (test) { test = test.tagName.match(/(IMG|NOSCRIPT)/); }

        if (test && test.length > 0) {
            let imageWrapper = document.createElement('div');
            let overlay = this.createOverlay();
            let poster = document.querySelector('.fc-header .poster-wrapper:not(.js-no-image-enlarger):not(.processed)');
            if (!poster) {
                return '';
            }
            let posterImg = poster.querySelector('img');

            imageWrapper.setAttribute('class', 'image-wrapper');
            poster.classList.add('inline-large');
            poster.classList.add('processed');

            imageWrapper.appendChild(posterImg);
            imageWrapper.appendChild(overlay);

            if (poster.querySelector('figcaption')) {
                poster.insertBefore(imageWrapper, poster.querySelector('figcaption'));
            } else {
                poster.appendChild(imageWrapper);
            }

            $(posterImg).unbind('click').on('click', function () {
                this.clickHandle(posterImg);
            }.bind(this));
        }
    }

    setListeners() {
        this.images.forEach(function (figure) {
            figure.classList.add('processed');
            $(figure).unbind('mouseover').one('mouseover', function () {
                this.hoverHandle(figure);
            }.bind(this));
        }.bind(this));
    }

    hoverHandle(figure) {
        let rgx = /\/imagecache\/inline-(large|xlarge)/i;
        let wrapper = figure.querySelector('.image-wrapper') || figure;
        let img = wrapper.querySelector('img');
        let cloneSrc = img.getAttribute('src').replace(rgx, '');
        let overlay = this.createOverlay();
        let newImage = document.createElement('img');

        newImage.setAttribute('src', cloneSrc);

        newImage.onload = function () {
            wrapper.insertBefore(newImage, img);
            wrapper.appendChild(overlay);
            wrapper.removeChild(img);

            figure.addEventListener('click', function () {
                this.clickHandle(newImage);
            }.bind(this));
        }.bind(this);
    }

    clickHandle(clone) {
        if (this.active) {
            this.rmHandle(clone);
            return;
        }
        this.active = true;
        this.currentScroll = function () { this.scrollHandle(clone); }.bind(this);
        document.addEventListener('scroll', this.currentScroll);
        this.getAspectRatio(clone);
    }

    scrollHandle(clone) {
        if (this.active) {
            this.rmHandle(clone);
            return;
        }
        return;
    }

    rmHandle(clone) {
        let navBar = document.querySelector('.nav-bar-wrapper');
        let figure = clone.parentNode.parentNode;

        document.removeEventListener('scroll', this.currentScroll);
        clone.style.transform = 'scale(1) translate(0, 0)';
        figure.classList.remove('enlarged');
        navBar.style.position = 'relative';
        this.article.style.overflow = 'hidden';
        this.active = false;
    }

    getAspectRatio(clone) {
        let figure = clone.parentNode.parentNode;

        let scrollTop = document.body.scrollTop;
        let cloneOffset = clone.getBoundingClientRect();

        let viewportCenterX = (window.innerWidth / 2);
        let viewportCenterY = scrollTop + (window.innerHeight / 2);

        let imageCenterX = cloneOffset.left + (clone.width / 2);
        let imageCenterY = (cloneOffset.top + scrollTop) + (clone.height / 2);

        let xTranslate = (viewportCenterX - imageCenterX);
        let yTranslate = (viewportCenterY - imageCenterY);
        let scaleFactor = this.getScaleFactor(clone);

        let cloneTransform = 'translate(' + xTranslate + 'px, ' + yTranslate + 'px) scale(' + scaleFactor + ')';

        clone.style.transform = cloneTransform;
        this.article.style.overflow = 'visible';
        this.animateNavs();

        figure.classList.add('enlarged');
    }

    animateNavs() {
        let navBar = document.querySelector('.nav-bar-wrapper');
        let adHeight = navBar.querySelector('.ad-wrapper').offsetHeight;
        let currentY = window.scrollY;

        navBar.style.position = 'static';

        if (adHeight < currentY) {
            this.navs.forEach(function (nav) {
                nav.style.top = '-60px';
            });
        }
    }

    getScaleFactor(clone) {
        let imgRatio = (clone.width / clone.height);
        let windowRatio = (window.innerWidth / window.innerHeight);
        let scaleFactor = window.innerHeight / clone.height;

        if ((clone.naturalHeight < window.innerHeight) && (clone.naturalWidth < window.innerWidth)) {
            scaleFactor = clone.naturalWidth / clone.width;
            return scaleFactor;
        }

        if (imgRatio > windowRatio) {
            scaleFactor = window.innerWidth / clone.width;
            return scaleFactor;
        }

        return scaleFactor;
    }

    createOverlay() {
        let overlay = document.createElement('div');
        overlay.setAttribute('class', 'overlay');
        return overlay;
    }


    on() {
        if (window.innerWidth < 1024) {
            return;
        }
        this.init();
    }
}

export default new ImageEnlarger();
